module.exports = __webpack_public_path__ + "img/22.e115ddd5.jpg";